import styled from "styled-components";

export const SpinnerContainer = styled.div`
  display: grid;
  place-content: center;
  width: 100%;
  height: 100%;
`;

export const UserImageContainer = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 48px;

  margin-bottom: 4px;
`;

export const UserImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 48px;

  margin-bottom: 4px;
  object-fit: cover;
`;

export const Name = styled.span`
  text-align: center;
  color: ${({ color }) => color};
  font-size: 16px;
  line-height: 18px;
  min-height: 18px;
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Info = styled.p`
  all: unset;
  color: ${({ color }) => color};
  text-align: center;
  font-size: 12px;
  min-height: 14px;
  font-weight: 400;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const TextColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: grid;
  place-content: center;

  cursor: pointer;

  position: absolute;

  ${({ position }) => {
    if (position === "bottom") {
      return `
        left: calc(50% - 12px);
        bottom: -12px;
      `;
    }
    if (position === "right") {
      return `
        top: 8px;
        right: -12px;
      `;
    }
  }}

  svg, circle, path {
    transition: color 100ms linear, fill 100ms linear;
  }

  &:hover {
    .delete-action {
      circle {
        fill: #ff5630;
      }
      path {
        fill: #fff;
      }
    }

    svg {
      color: #0065ff !important;
      fill: #fff !important;
    }
  }
`;
